<template>
  <div>
    <SupplierOrderFilters :number.sync="payload.number" :orderStatusId.sync="payload.orderStatusId" :surgeryId.sync="payload.surgeryId" @apply="getSupplierOrders(payload)"/>
    <loading v-show="loading" />
    <v-card v-show="!loading" elevation="4">
      <v-app-bar flat dense elevation="0" color="transparent">
        <v-toolbar-title> <h4>Supplier Orders</h4> </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-app-bar>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <template>
          <v-data-table
            :headers="headers"
            :items="supplierOrders"
            show-select
            v-model="selected"
            :server-items-length="totalItems"
            :page.sync="pagination.page"
            :options.sync="pagination"
            :items-per-page.sync="pagination.itemsPerPage"
            @pagination="updatePagination"
            :disable-pagination="false"
            :footer-props="{
              disablePagination: false,
              disableItemsPerPage: false
            }"
            @click:row="edit($event.id)"
            class="elevation-0 black--text"
          >
            <template v-slot:header.data-table-select="{ props, on }">
              <!-- COLOR Not working when props.indeterminate is true -->
              <v-simple-checkbox
                color="primary"
                v-ripple
                v-bind="props"
                v-on="on"
              ></v-simple-checkbox>
            </template>
            <template v-slot:item.data-table-select="{ isSelected, select }">
              <v-simple-checkbox
                color="primary"
                v-ripple
                :value="isSelected"
                @input="select($event)"
              ></v-simple-checkbox>
            </template>
            <template v-slot:item.action="{ item }">
              <v-menu offset-y bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn dark icon v-bind="attrs" v-on="on">
                    <v-icon class="gray--text">more_vert</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item link>
                    <v-list-item-title @click="edit(item.id)"
                      >Edit</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item link>
                    <v-list-item-title @click="deleteAndRefresh(item.id)"
                      >Delete</v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </template>
        <v-divider></v-divider>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import Helpers from "@/mixins/helpers";
import SupplierOrderFilters from "./SupplierOrderFilters";
export default {
  mixins: [Helpers],
  components: {
    SupplierOrderFilters
  },
  data() {
    let vm = this;
    return {
      supplierId: null,
      loading: true,
      selected: [],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: false,
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      headers: [
        {
          text: "Id",
          align: "left",
          value: "number"
        },
        {
          text: "Subtotal",
          align: "left",
          value: "invoice.subTotal"
        },
        {
          text: "Shipping fee",
          align: "left",
          value: "invoice.shippingFee"
        },
        {
          text: "Order Number",
          align: "left",
          value: "order.number"
        },
        {
          text: "User email",
          align: "left",
          value: "order.user.email"
        }
        // { text: "", value: "action", align: "right" }
      ],
      payload: {
        from: 0,
        to: 10,
        number: null,
        surgeryId: null,
        orderStatusId: null
      }
    };
  },
  computed: {
    supplierOrders() {
      return this.$store.state.supplierorders.supplierOrders;
    },
    totalItems() {
      return this.$store.state.supplierorders.total;
    }
  },
  created() {
    this.getSupplierOrders(this.payload);
  },
  methods: {
    async getSupplierOrders(payload) {
      this.loading = true;
      await this.$store.dispatch(
        "supplierorders/LOAD_SUPPLIER_ORDERS",
        payload
      );
      this.loading = false;
    },
    updatePagination(pagination) {
      let payload = this.payload;
      payload.from =
        pagination.page * pagination.itemsPerPage - pagination.itemsPerPage;
      payload.to =
        pagination.itemsPerPage === -1
          ? this.totalItems
          : pagination.itemsPerPage;
      this.getSupplierOrders(payload);
    },
    async deleteAndRefresh(id) {
      let res = await this.destroy(id);
      if (res) {
        let payload = {
          from:
            this.pagination.page * this.pagination.itemsPerPage -
            this.pagination.itemsPerPage,
          to:
            this.pagination.itemsPerPage === -1
              ? this.totalItems
              : this.pagination.itemsPerPage
        };
        this.getSupplierOrders(payload);
      }
    }
  }
};
</script>
